<template>
  <div class="container-fluid  content_background_color_blue2 pl-5 pt-5 pb-5">
    <nav aria-label="breadcrumb" >
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a href="/">Главная</a></li>


        <li class="breadcrumb-item active" aria-current="page">Блог</li>
      </ol>
    </nav>

    <div class="col-lg-12 col-12">
      <card>
        <!-- shape Hero -->

        <!-- 1st Hero Variation -->
        <div class="row alert">
          <button type="danger" class="btn side2" v-if="islogin" @click="callWritePost">Написать пост
          </button>
          <button type="danger" class="btn side2" v-if="islogin==false " @click="callModalLogin">
            Авторизуйтесь,чтобы написать пост
          </button>
        </div>
      </card>

      <card class="col-12 col-sm-12 mt-5 ml-1 "
            v-for="post in posts"
            :key="post.last_id">
        <div class="col-12    mb-2">

          <div class=" ">
            <editorjsrender   :blocks_json="post.short.blocks"></editorjsrender>
          </div>

          <div class="col-lg-12 col-10 mt-2">

            <p><a class="btn side4" :href="'/'+post.category_post.alias">{{ post.category_post.title}}</a>  <i class="fa fa-calendar-times-o"></i> {{ post.created_at }}
              <router-link class="btn side2 " :to="{name: 'post', params: {alias:post.category_post.alias, id: post.last_id }}"
              >Посмотреть
              </router-link>
            </p>


          </div>
        </div>

      </card>



      <card class="col-12 col-sm-12 mt-5 ml-1 " v-if="count>current">
        <div class="row ">
          <button class="btn btn-default" @click="loadPosts()">Загрузить еще</button>

        </div>
      </card>

    </div>

  </div>
</template>

<script>
import {eventBus} from "@/main";
import Editorjsrender from "../../models/Editorjsrender.vue";
import Api from "@/models/Api";
import Vue from "vue";

export default {
  name: "Posts",
  data: function () {
    return {
      user: null,
      islogin: false,
      current: 0,
      count: 0,
      posts: [],
      image_url: null,
    }
  },
  mounted() {
    var app = this;
    app.image_url = Vue.config.IMAGE_URL;
    if (app.$store.getters.ISAUTH) {
      var tmpUser = app.$store.getters.USER;

      app.user = tmpUser;
      app.islogin = true;


    }

    eventBus.$on('user_is_login', user => {
      this.islogin = false;
      if (typeof user === 'object') {
        if (user.api_token) {
          app.user = user;
          app.islogin = true;

        }
      }


    });
    app.loadPosts();
  },
  methods: {
    callModalLogin() {
      eventBus.$emit("call_modal_add_project", {type: "login",})
      {

      }
    },
    loadPosts() {
      var app = this;
      Api.loadPosts(20, app.current, function (data) {
        app.count = data.count;
        app.posts = app.posts.concat(data.posts);
        app.current = app.current + data.posts.length;
        console.log('current');
        console.log(app.current);
        console.log('count');
        console.log(app.count);

      })
    },
    callWritePost() {
      var params = {

        type: "post_new",

        modal_title: "Добавить пост",

        json: {
          "blocks": [{
            "type": "header",
            "data": {
              "text": "Название вашего поста",
              "level": 2
            }
          }]
        }
      };
      eventBus.$emit("call_modal_add_project", params)
      {


      }
    }
  },
  components: {
    'editorjsrender': Editorjsrender,
  }
}
</script>

<style scoped>

</style>